import React from "react";
import { Table, Modal } from "react-bootstrap";
import axios from "axios";
import ReactPaginate from "react-paginate";
import "./Results.scss";
import '../../scss/components/buttons.scss';
import '../../scss/style.scss'
import hosts from '../Hosts/animals.json';
import { Divider, Button } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { env } from 'env';
import CSVDownload from "components/CSVDownload/CSVDownload";
import { pathogen } from "pages/Hosts/pathogen";
import { data } from "../Annotation/data";
import test from "../Interactome/test.gif"
const urlParams = new URLSearchParams(window.location.search);

const tdata = urlParams.get("id");
// const tdata = 'hpinet1696211121764results'

var onlyOnce = false;


let genes;
let dgenes;

function onlyNumbers(str) {
  return /^[0-9]+$/.test(str);
}

function formatList(list) {
  if (list.length === 0) return "";
  if (list.length === 1) return list[0];
  for (let i = 0; i < list.length; i++) {
    if (list[i] === 'domain') {
      list[i] = 'Domain';
    } else if (list[i] === 'interolog') {
      list[i] = 'Interolog';
    } else if (list[i] === 'phylo') {
      list[i] = 'Phylo-profiling';
    } else if (list[i] === 'gosim') {
      list[i] = 'GOSemSim';
    }
  }
  let formattedString = list.slice(0, -1).join(", ") + " and " + list[list.length - 1];
  return formattedString;
}

export default class Results extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      List: [],
      dList: [],
      MasterChecked: false,
      SelectedList: [],
      offset: 0,
      perPage: 100,
      currentPage: 0,
      pageCount: 20,
      host: '',
      hostCommonName: '',
      pathogen: '',
      hostp: 0,
      pathogenp: 0,
      dResult: [],
      isOpen: false,
      expressionOpen: false,
      species: '',
      domsp: '',
      categories: [],
      idt: [],
      genes: genes,
      dgenes: dgenes,
      resultid: tdata,
      hasExecuted: false,
      paramsList: {},
      category: 'consensus',
      fetched: false,
      intdb: '',
    };
    this.handlePageClick = this.handlePageClick.bind(this);
    // this.handleChangeMotif = this.handleChangeMotif.bind(this);
    // this.downloadResults = this.downloadResults.bind(this)

  };

  openModel = () => this.setState({ isOpen: true, dList: [] });
  closeModel = () => this.setState({ isOpen: false });

  expressionModalOpen = () => this.setState({ expressionOpen: true });
  expressionModalClose = () => this.setState({ expressionOpen: false });

  async fetchResults() {
    let categories = [];
    let paramsList = {}
    let result = await axios.get(`${env.BACKEND}/api/params?resultsId=${tdata}`)
    result = result.data
    if (result.length === 0) {
      return;
    }
    const combinationType = result[0].combinationType;
    const host = result[0].hspecies;
    const hostCommonName = hosts.find(item => item.sname === host.replace('_', ' ')).name
    const pathogen = result[0].pspecies;
    for (let i = 0; i < result.length; i++) {
      if (i === 0 && (combinationType === 'consensus' || combinationType === 'concatenation')) continue;
      let params = result[i];
      categories.push(params.category)
      paramsList[params.category] = params;
    }
    if (categories.length === 1 && categories[0] === 'domain') {
      if (paramsList[categories[0]].genes === '') {
        genes = []
      }
      if (paramsList[categories[0]].genes !== '') {
        genes = paramsList[categories[0]].genes.split(", ")
        dgenes = genes['0'].split(",")
      }
    }

    if (categories.length === 1 && categories[0] === 'domain') {
      const domdbs = paramsList[categories[0]].domdbs.map((element) => {
        return element.toLowerCase();
      });
      const postBody = {
        host: host,
        pathogen: pathogen,
        page: this.state.currentPage,
        size: this.state.perPage,
        genes: this.state.dgenes,
        idt: this.state.idt,
        domdbs: domdbs,
        keyword: paramsList[categories[0]].keyword,
        searchType: paramsList[categories[0]].searchType,
        categories: categories,
        paramsList: paramsList,
      }
      this.openModel();
      axios
        .get(
          `${env.BACKEND}/api/domain?resultsId=${tdata}`, postBody, { crossDomain: true }
        )
        .then((res) => {
          const dList = res.data.data;
          const requestBody = res.data.requestBody;
          const dl = Math.ceil(res.data.total / this.state.perPage);
          this.setState({
            host: host,
            hostCommonName: hostCommonName,
            pathogen: pathogen,
            List: dList,
            requestBody: requestBody,
            pageCount: dl,
            total: parseInt(res.data.total),
            hostp: res.data.hostcount,
            pathogenp: res.data.pathogencount,
            dResult: res.data.results,
            resultid: res.data.resultid,
            categories: categories,
            paramsList: paramsList,
            combinationType: 'single',
            fetched: true,
          });
          this.closeModel();
        }).catch(e => {
          console.log(e);
        });
    } else if (categories.length === 1) {
      axios
        .get(
          `${env.BACKEND}/api/results/?results=${tdata}&category=${categories[0]}&page=${this.state.currentPage}&size=${this.state.perPage}`
        )
        .then((res) => {
          const List = res.data.results;
          const dl = Math.ceil(res.data.total / this.state.perPage);

          this.setState({
            host: host,
            hostCommonName: hostCommonName,
            pathogen: pathogen,
            List: List,
            pageCount: dl,
            total: parseInt(res.data.total),
            hostp: res.data.hostcount,
            pathogenp: res.data.pathogencount,
            dResult: res.data.results,
            categories: categories,
            paramsList: paramsList,
            combinationType: 'single',
            fetched: true,
          });

          if (tdata === "Error" && !onlyOnce) {
            alert("There was an error processing your submission.");
            onlyOnce = true;
          }
        });
    } else {
      axios
        .get(
          `${env.BACKEND}/api/results/?results=${tdata}&page=${this.state.currentPage}&size=${this.state.perPage}`
        )
        .then((res) => {
          const dList = res.data.results;
          const requestBody = res.data.requestBody;
          const dl = Math.ceil(res.data.total / this.state.perPage);
          this.setState({
            host: host,
            hostCommonName: hostCommonName,
            pathogen: pathogen,
            dList: dList,
            List: dList,
            requestBody: requestBody,
            pageCount: dl,
            total: parseInt(res.data.total),
            hostp: res.data.hostcount,
            pathogenp: res.data.pathogencount,
            dResult: res.data.results,
            resultid: tdata,
            categories: categories,
            paramsList: paramsList,
            combinationType: combinationType,
            fetched: true,
          });
        }).catch(e => {
          console.log(e);
        });
    }
  }

  componentDidMount() {
    if (!this.state.hasExecuted) {
      this.fetchResults();
      this.setState({
        hasExecuted: true,
      });
    }
  }

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
      },
      () => {
        this.fetchResults();
      }
    );
  };

  // Select/ UnSelect Table rows
  onMasterCheck(e) {
    let tempList = this.state.List;
    // Check/ UnCheck All Items
    tempList.map((user) => (user.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      List: tempList,
      SelectedList: this.state.List.filter((e) => e.selected),
    });
  }

  // Update List Item's state and Master Checkbox State
  onItemCheck(e, item) {
    let tempList = this.state.List;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });

    //To Control Master Checkbox State
    const totalItems = this.state.List.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;

    // Update State
    this.setState({
      MasterChecked: totalItems === totalCheckedItems,
      List: tempList,
      SelectedList: this.state.List.filter((e) => e.selected),
    });
  }

  render() {
    let results;
    let middle = '';
    let pdata = this.state.paramsList;
    const categories = this.state.categories;
    const combinationType = this.state.combinationType;
    const host = this.state.host;
    const hostCommonName = this.state.hostCommonName;
    const pathogenName = this.state.pathogen;
    if (tdata) {
      localStorage.setItem("resultid", JSON.stringify({
        ttdata: tdata,
        stype: categories
      }))
    }

    if (this.state.List.length > 1 || this.state.dList.length > 1) {
      let st = this.state.offset + 1;
      let en;
      if (en > this.state.total) {
        en = this.state.total;
      }
      else {
        en = this.state.offset + this.state.perPage;
      }

      middle = (
        <span>
          <div className="row flex-lg-row align-items-center g-2 my-2 mx-2">
            <div className="col-md-2">
              <CSVDownload resultsId={tdata} />
            </div>
            <div className="col-md-8">
              <h5 style={{ fontSize: '16px', paddingLeft: '20px' }}>
                Showing {st} to {en} of <b>{this.state.total}</b> interactions (Host Protein: {this.state.hostp} and Pathogen Protein: {this.state.pathogenp})
              </h5>
            </div>
            {this.state.total <= 20000 && (
              <div className="col-md-2">
                <a href={`${env.BASE_URL}/network/?resultid=${this.state.resultid}&rtype=${categories}`} target="_blank" rel="noopener noreferrer">
                  <Button type="primary" shape="round" size="large">
                    <b>Visualize Network</b>
                  </Button>
                </a>
              </div>
            )}
          </div>
          <Divider />
        </span>
      );
    }
    if (this.state.List.length > 0 && !('result' in this.state.List[0])) {
      results = (<>
        {middle}
        <Table responsive className="kbl-table table-borderless">
          <thead className="kbl-thead">
            {combinationType !== "concatenation" && categories.length > 1 && (
              <>
                <tr>
                  <th colspan="4"></th>
                  {categories.includes('interolog') && (
                    <>
                      <th className="consensus-header" colspan="7">Interolog</th>
                    </>
                  )}
                  {categories.includes('domain') && (
                    <>
                      <th className="consensus-header" colspan="7">Domain</th>
                    </>
                  )}
                  {categories.includes('gosim') && (
                    <>
                      <th className="consensus-header" colspan="3">GOSemSim</th>
                    </>
                  )}
                  {categories.includes('phylo') && (
                    <>
                      <th className="consensus-header" colspan="3">Phylo</th>
                    </>
                  )}
                </tr>
              </>
            )}
            <tr>
              <th>Host</th>
              <th>Expression {' '}
                <InfoCircleOutlined onClick={this.expressionModalOpen} />
              </th>
              <th>Pathogen</th>
              <th>Annotation</th>
              {combinationType !== 'concatenation' && categories.includes('interolog') && (
                <>
                  <th className="consensus-header-border-left">InteractorA</th>
                  <th>InteractorB</th>
                  <th>Source</th>
                  <th>Method</th>
                  <th>Type</th>
                  <th>Confidence</th>
                  <th className="consensus-header-border-right">PMID</th>
                </>
              )}
              {combinationType !== 'concatenation' && categories.includes('domain') && (
                <>
                  <th className="consensus-header-border-left">Source</th>
                  <th>Host PFAM ID</th>
                  <th>Pathogen PFAM ID</th>
                  <th>Host Domain Name</th>
                  <th>Host Interpro</th>
                  <th>Pathogen Domain Name</th>
                  <th className="consensus-header-border-right">Pathogen Interpro</th>
                </>
              )}
              {combinationType !== 'concatenation' && categories.includes('gosim') && (
                <>
                  <th className="consensus-header-border-left">Host GO Terms</th>
                  <th>Pathogen Go Terms</th>
                  <th className="consensus-header-border-right">Score</th>

                </>
              )}
              {combinationType !== 'concatenation' && categories.includes('phylo') && (
                <>
                  <th className="consensus-header">Score</th>
                </>
              )}
              {combinationType === 'concatenation' && (
                <>
                  <th className="consensus-header">Method</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {this.state.isOpen && (
              <tr>
                <td colSpan={6}>
                  {/* <ReactLoading type={'spokes'} color={'#bff1de'} /> */}
                  <img
                    src={test}
                    className="loading"
                    height="50px"
                    alt=""
                  ></img>
                </td>
              </tr>
            )}
            {this.state.List.map((result, index) => (
              <tr key={index + 1} className={result.selected ? "selected" : ""}>
                <td id="hostProtein">
                  {host === "Bos_grunniens" && (
                    <a
                      href={`https://useast.ensembl.org/Multi/Search/Results?q=${result["host_protein"]};site=ensembl_all;page=1`}
                      target="_blank"
                      rel="noreferrer"
                      className="host"
                    >
                      {result["host_protein"]}
                    </a>
                  )}
                  {host !== "Bos_grunniens" && (
                    <a
                      href={`https://www.ncbi.nlm.nih.gov/protein/${result["host_protein"]}`}
                      target="_blank"
                      rel="noreferrer"
                      className="host"
                    >
                      {result["host_protein"]}
                    </a>
                  )}
                </td>
                <td id="expression">
                  <span style={{ color: 'red' }}>DOWN: </span>{result["downCount"]}<br></br>
                  <span style={{ color: 'blue' }}>UP: </span>{result["upCount"]}
                  <a
                    href={`/apinet/expression/Bos_taurus/Mycobacterium_bovis/${result["host_protein"]}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                  <br />
                    <Button type="link" shape="round" size={'small'}>See experiments</Button>
                  </a>
                </td>
                <td id="pathogenProtein">
                  {pathogenName === "Candida_auris" && (
                    <a
                      href={`https://www.uniprot.org/uniparc?query=${result["pathogen_protein"]}`}
                      target="_blank"
                      rel="noreferrer"
                      className="pathogen"
                    >
                      {result["host_protein"]}
                    </a>
                  )}
                  {pathogenName !== "Candida_auris" && (
                    <a
                      href={`https://www.ncbi.nlm.nih.gov/protein/${result["pathogen_protein"]}`}
                      target="_blank"
                      rel="noreferrer"
                      className="pathogen"
                    >
                      {result["pathogen_protein"]}
                    </a>
                  )}
                </td>
                <td id="annotation">
                  <a
                    href={`${env.BASE_URL}/annotation/?host=${host}&pathogen=${pathogenName}&hid=${result["host_protein"]}&pid=${result["pathogen_protein"]}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Button type="link" shape="round" size={'small'}>View</Button>
                  </a>
                </td>
                {combinationType !== "concatenation" && categories.includes('interolog') && (
                  <>
                    <td className="consensus-table-border-left">
                      {result['intdb_x'] === 'string' && (
                        <a
                          href={`https://string-db.org/cgi/network?identifiers=${result["ProteinA"]}`}
                          target="_blank"
                          rel="noreferrer"
                          className="interactor"
                        >
                          {result["ProteinA"]}
                        </a>
                      )}
                      {result['intdb_x'] !== 'string' && (
                        <a
                          href={`https://www.ncbi.nlm.nih.gov/protein/${result["ProteinA"]}`}
                          target="_blank"
                          rel="noreferrer"
                          className="interactor"
                        >
                          {result["ProteinA"]}
                        </a>
                      )}
                    </td>
                    <td>
                    {result['intdb_x'] === 'string' && (
                        <a
                          href={`https://string-db.org/cgi/network?identifiers=${result["ProteinB"]}`}
                          target="_blank"
                          rel="noreferrer"
                          className="interactor"
                        >
                          {result["ProteinB"]}
                        </a>
                      )}
                      {result['intdb_x'] !== 'string' && (
                        <a
                          href={`https://www.ncbi.nlm.nih.gov/protein/${result["ProteinB"]}`}
                          target="_blank"
                          rel="noreferrer"
                          className="interactor"
                        >
                          {result["ProteinB"]}
                        </a>
                      )}
                    </td>
                    <td>{result["intdb_x"]}</td>
                    <td>{result["Method"]}</td>
                    <td>{result["Type"]}</td>
                    <td>{result["Confidence"]}</td>
                    <td className="consensus-table-border-right">
                      {(() => {
                        if (onlyNumbers(result['PMID'])) {
                          return (
                            <a
                              href={` https://pubmed.ncbi.nlm.nih.gov/${result["PMID"]}/`}
                              target="_blank"
                              rel="noreferrer"
                              className="interactor"
                            >
                              {result["PMID"]}
                            </a>
                          )
                        } else {
                          return (
                            <>
                              {result["PMID"]}
                            </>
                          )
                        }
                      })()}
                    </td>
                  </>)}
                {combinationType !== "concatenation" && categories.includes('domain') && (
                  <>
                    <td className="consensus-table-border-left">{result["intdb"]}</td>
                    <td>
                      <a
                        href={`https://www.ebi.ac.uk/interpro/entry/pfam/${result["pfamA"]}`}
                        target="_blank"
                        rel="noreferrer"
                        className="host"
                      >
                        {result["pfamA"]}
                      </a>
                    </td>
                    <td>
                      <a
                        href={`https://www.ebi.ac.uk/interpro/entry/pfam/${result["pfamB"]}`}
                        target="_blank"
                        rel="noreferrer"
                        className="pathogen"
                      >
                        {result["pfamB"]}
                      </a>
                    </td>
                    <td>{result["domainA_name"]}</td>
                    <td>
                      <a
                        href={`https://www.ebi.ac.uk/interpro/entry/InterPro/${result["interproA"]}`}
                        target="_blank"
                        rel="noreferrer"
                        className="host"
                      >
                        {result["interproA"]}
                      </a>
                    </td>
                    <td>{result["domainB_name"]}</td>
                    <td className="consensus-table-border-right">
                      <a
                        href={`https://www.ebi.ac.uk/interpro/entry/InterPro/${result["interproB"]}`}
                        target="_blank"
                        rel="noreferrer"
                        className="pathogen"
                      >
                        {result["interproA"]}
                      </a>
                    </td>
                  </>)}
                {combinationType !== "concatenation" && categories.includes('gosim') && (
                  <>
                    <td className="consensus-table-border-left">{result["Host_GO"]}</td>
                    <td>{result["Pathogen_GO"]}</td>
                    <td className="consensus-table-border-right">{result["gosim_score"]}</td>
                  </>
                )}
                {combinationType !== "concatenation" && categories.includes('phylo') && (
                  <>
                    <td className="consensus-table-border-left">{parseFloat(result["phylo_score"]).toFixed(2)}</td>
                  </>
                )}
                {combinationType === "concatenation" && (
                  <>
                    <td className="consensus-table-border-left">{result["method"]}</td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
        <Divider />

        <ReactPaginate
          forcePage={this.state.currentPage}
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={this.state.pageCount}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={this.handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"}
          ellipsisItem={null}
        />
      </>)
    }
    else {
      results = (
        <>
          <h5> No interactions found on based on these parameters. Try modifying your search parameters.</h5>
        </>
      )
    }
    return (
      <div className="container">
        <Modal show={this.state.expressionOpen} onHide={this.expressionModalClose}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Title>
            <h5 className="my-2 text-center">About Expression</h5>
          </Modal.Title>
          <Modal.Body>
            <p className="info">
              Number of experiments where the protein's corresponding genes appear downregulated and upregulated. These experiments are filtered by FDR ≤ 0.05 and logFC ≥ 1.5-fold change. Different parameters can lead to different down/upregulated genes.
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button type="danger" shape="round" onClick={this.expressionModalClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {!this.state.fetched && (
          <>
            <br></br>
            <h5>Fetching results...</h5>
          </>
        )}
        {categories.length === 1 && categories[0] === 'interolog' && (
          <>
            <Divider />
            <div className="row flex-lg-row align-items-center ">
              <h5>
                <b>Host:</b> {hostCommonName} <i>({data[hostCommonName]})</i>&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                <b>Pathogen:</b> <i>{pathogen[pathogenName]}</i>&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                <b>Method:</b>  Interolog</h5>
              <Divider />
              <div className="col-md-2">
                <b>Parameters:</b>
              </div>
              <div className="col-md-5">
                <div className="row mx-4">
                  <div className="col-md-2 heading2">
                    <b>Host:</b>
                  </div>
                  <div className="col-md-10">
                    {" "}
                    Evalue:&nbsp; {pdata['interolog'].he} &nbsp; &nbsp; Identity:&nbsp;{" "}
                    {pdata['interolog'].hi} &nbsp; &nbsp; Coverage:&nbsp; {pdata['interolog'].hc}
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="row mx-4">
                  <div className="col-md-2 heading2">
                    <b>Pathogen:</b>
                  </div>
                  <div className="col-md-10">
                    {" "}
                    evalue:&nbsp; {pdata['interolog'].pe}&nbsp; &nbsp; identity:&nbsp;{" "}
                    {pdata['interolog'].pi} &nbsp; &nbsp; coverage:&nbsp; {pdata['interolog'].pc}
                  </div>
                </div>
              </div>
              <Divider />
            </div>
            {results}
          </>
        )}
        {categories.length === 1 && categories[0] === 'gosim' && (
          <>
            <Divider />
            <div className="row flex-lg-row align-items-center ">
              <h5> <b>Host:</b> <i>{hostCommonName}</i> ({data[hostCommonName]})&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <b>Pathogen:</b> <i>{pathogen[pathogenName]}</i>&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;<b>Method:</b>  Gene Ontology Semantic Similarity </h5>
              <Divider />
              <div className="col-md-3">
                <b>Parameters:</b>
              </div>
              <div className="col-md-3">
                <b>Method:</b>&nbsp;&nbsp;{pdata['gosim'].measure}
              </div>
              {pdata['gosim'].measure !== 'Wang' && (
                <div className="col-md-3">
                  <b>OrgDb:</b>&nbsp;&nbsp;{pdata['gosim'].orgDb}
                </div>
              )}
              <div className="col-md-3">
                <b>Score Threshold:</b>&nbsp;&nbsp;{pdata['gosim'].minSimilarity}
              </div>
              <Divider />
            </div>

            {results}
          </>
        )}
        {categories.length === 1 && categories[0] === 'phylo' && (
          <>
            <Divider />
            <div className="row flex-lg-row align-items-center ">
              <h5> <b>Host:</b> <i>{hostCommonName}</i> ({data[hostCommonName]})&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <b>Pathogen:</b> <i>{pathogen[pathogenName]}</i>&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;<b>Method:</b>  Phylogenetic Profiling</h5>
              <Divider />
              <div className="col-md-2">
                <b>Parameters:</b>
              </div>
              <div className="col-md-5">
                <div className="row mx-4">
                  <div className="col-md-2 heading2">
                    <b>Host:</b>
                  </div>
                  <div className="col-md-10">
                    {" "}
                    Evalue:&nbsp; {pdata['phylo'].he}&nbsp; &nbsp; Identity:&nbsp;{" "}
                    {pdata['phylo'].hi} &nbsp; &nbsp; Coverage:&nbsp; {pdata['phylo'].hc}
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="row mx-4">
                  <div className="col-md-2 heading2">
                    <b>Pathogen:</b>
                  </div>
                  <div className="col-md-10">
                    {" "}
                    evalue:&nbsp; {pdata['phylo'].pe}&nbsp; &nbsp; identity:&nbsp;{" "}
                    {pdata['phylo'].pi} &nbsp; &nbsp; coverage:&nbsp; {pdata['phylo'].pc}
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <div className="row w-100">
                  <span className="col-md-2 offset-md-5 heading2"><b>Threshold:</b></span> {pdata['phylo'].threshold}
                </div>
              </div>
              <Divider />
            </div>
            {results}
          </>
        )}
        {categories.length === 1 && categories[0] === 'domain' && (
          <>
            <Divider />
            <div className="row flex-lg-row align-items-center ">
              <h5> <b>Host:</b> <i>{hostCommonName}</i> ({data[hostCommonName]})&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <b>Pathogen:</b> <i>{pathogen[pathogenName]}</i></h5>

              <Divider />
              <div className="heading2">Your selected domain databases: &nbsp;{pdata['domain'].domdbs.toString()}</div>
            </div>

            <Divider />
            {results}
          </>)}
        {categories.length > 1 && (
          <>
            <>
              <Divider />
              <div className="row flex-lg-row align-items-center ">
                <h5>
                  <b>Host:</b> <i>{hostCommonName}</i> ({data[hostCommonName]})&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                  <b>Pathogen:</b> <i>{pathogen[pathogenName]}</i>&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                  <b>Methods:</b>  {formatList(categories)}
                </h5>
                <Divider />
                {'interolog' in pdata && (
                  <>
                    <div className="col-md-2">
                      <b>Interolog parameters:</b>
                    </div>
                    <div className="col-md-5">
                      <div className="row mx-4">
                        <div className="col-md-2 heading2">
                          <b>Host:</b>
                        </div>
                        <div className="col-md-10">
                          {" "}
                          Evalue:&nbsp; {pdata['interolog'].he} &nbsp; &nbsp; Identity:&nbsp;{" "}
                          {pdata['interolog'].hi} &nbsp; &nbsp; Coverage:&nbsp; {pdata['interolog'].hc}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="row mx-4">
                        <div className="col-md-2 heading2">
                          <b>Pathogen:</b>
                        </div>
                        <div className="col-md-10">
                          {" "}
                          evalue:&nbsp; {pdata['interolog'].pe}&nbsp; &nbsp; identity:&nbsp;{" "}
                          {pdata['interolog'].pi} &nbsp; &nbsp; coverage:&nbsp; {pdata['interolog'].pc}
                        </div>
                      </div>
                    </div>
                    <Divider />
                  </>
                )}
                {'domain' in pdata && (
                  <>
                    Your selected domain databases: &nbsp;{pdata['domain'].domdbs.toString()}
                    <Divider />
                  </>
                )}
                {'phylo' in pdata && (
                  <>
                    <div className="col-md-2">
                      <b>Phylo-profiling parameters:</b>
                    </div>
                    <div className="col-md-10">
                      <div className="row flex-lg-row align-items-center">
                        <div className="col-md-6">
                          <div className="row mx-4">
                            <div className="col-md-2 heading2">
                              <b>Host:</b>
                            </div>
                            <div className="col-md-10">
                              {" "}
                              Evalue:&nbsp; {pdata['phylo'].he} &nbsp; &nbsp; Identity:&nbsp;{" "}
                              {pdata['phylo'].hi} &nbsp; &nbsp; Coverage:&nbsp; {pdata['phylo'].hc}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="row mx-4">
                            <div className="col-md-2 heading2">
                              <b>Pathogen:</b>
                            </div>
                            <div className="col-md-10">
                              {" "}
                              evalue:&nbsp; {pdata['phylo'].pe}&nbsp; &nbsp; identity:&nbsp;{" "}
                              {pdata['phylo'].pi} &nbsp; &nbsp; coverage:&nbsp; {pdata['phylo'].pc}
                            </div>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="row w-100">
                            <span className="col-md-4 offset-md-3 heading2"><b>Threshold:</b></span> {pdata['phylo'].threshold}
                          </div>
                        </div>
                      </div>
                    </div>
                    <Divider />
                  </>
                )}
                {'gosim' in pdata && (
                  <>
                    <div className="col-md-3">
                      <b>Parameters:</b>
                    </div>
                    <div className="col-md-3">
                      <b>Method:</b>&nbsp;&nbsp;{pdata['gosim'].measure}
                    </div>
                    {pdata['gosim'].measure !== 'Wang' && (
                      <div className="col-md-3">
                        <b>OrgDb:</b>&nbsp;&nbsp;{pdata['gosim'].orgDb}
                      </div>
                    )}
                    <div className="col-md-3">
                      <b>Score Threshold:</b>&nbsp;&nbsp;{pdata['gosim'].minSimilarity}
                    </div>
                    <Divider />
                  </>
                )}
              </div>
              {results}
            </>
          </>
        )}
      </div>
    );
  }
}
